import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Controls, validators } from 'shared/helper/form';
import { T } from 'shared/helper/translate';
var RubriqSetupOnboardingStep = function RubriqSetupOnboardingStep(_ref) {
  var methodsOnboarding = _ref.methodsOnboarding,
    handleSubmit = _ref.handleSubmit,
    submitting = _ref.submitting;
  var Form = Controls.Form,
    Text = Controls.Text;
  var notEmpty = validators.notEmpty;
  return /*#__PURE__*/React.createElement(Form, {
    methods: methodsOnboarding,
    onSubmit: handleSubmit,
    className: "d-flex flex-column gap-sm-4 justify-content-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-2"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "m-0 fw-semibold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.abstract-setup-onboarding-step-prompt"
  })), /*#__PURE__*/React.createElement("p", {
    className: "p-0 m-0 text-secondary"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.abstract-setup-onboarding-step-helper"
  }))), /*#__PURE__*/React.createElement(Text, {
    name: "title",
    label: "Name",
    validators: {
      notEmpty: notEmpty
    },
    required: false,
    styles: {
      label: 'text-transform-none fw-semibold mb-2'
    },
    messages: {
      notEmpty: 'curie.abstract-title-missing-error'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-end gap-3"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-primary btn-squared py-1 px-sm-5 w-mobile-100",
    disabled: submitting
  }, /*#__PURE__*/React.createElement(T, {
    source: "next"
  }), submitting && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "ms-1",
    spin: true
  }))));
};
export default RubriqSetupOnboardingStep;